import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Research</h1>
                <p>Home &gt; Research &gt; PH.D Abstract 2021</p>
            </div>
        </div>
    )
}

export default Hero;